import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Header from "../../common/header";
import Footer from "../../common/footer";
import Sidebar from "../../common/sidebar";

import Toaster from "../../components/Toaster";

import ReactChipInput from "../../common/react-chips/src/index.tsx";
import "../../common/react-chips/src/styles.css";

import { api } from "../../Services/index";
import BounceLoader from "react-spinners/BounceLoader";
import LoadingOverlay from "../../common/Loader";
import "../dcg_questions/style.css";

import SweetAlert from "react-bootstrap-sweetalert";
import IdleTimer from "../../common/IdleTimer";
// export const dataDCGQuestionsResponseType = [
//     { responseTypeId: 1, responseType: 'FreeText' },
//     { responseTypeId: 2, responseType: 'SingleSelection' },
//     { responseTypeId: 3, responseType: 'RadioButton' },
//     { responseTypeId: 4, responseType: 'CheckBox' }
//   ];

export const dataDCGQuestionsResponseType = [
  { responseTypeId: "TextArea", responseType: "Text Area (Multi Line - 500)" },
  { responseTypeId: "FreeText", responseType: "Free Text Entry (100)" },
  { responseTypeId: "SingleSelection", responseType: "Single Select Dropdown" },
  {
    responseTypeId: "RadioButton",
    responseType: "Single Select Radio Buttons",
  },
  { responseTypeId: "CheckBox", responseType: "Multi Select Checkboxes" },
];

export const dataResponseOptions = [
  { optionid: 1, label: "Expresso" },
  { optionid: 2, label: "Oak" },
  { optionid: 3, label: "Mahogany" },
  { optionid: 4, label: "Black" },
];
const loaderStyle = {
  color: "#f3f3f3",
};
const chipStyle = {
  color: "white",
};

class DCGQuestions extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      tab: 5,
      spinnerLoading: false,

      toasterMessage: "",
      toasterType: "",

      loginname: "",
      userloginid: "",

      responseType: dataDCGQuestionsResponseType,
      dcgForm: [
        {
          sections: [
            {
              sectionid: null,
              is_delete: false,
              label: "",
              description: "",
              questions: [
                {
                  questionid: null,
                  is_delete: false,
                  questionorder: null,
                  label: "",
                  labellength: 0,
                  eloquaid: null,
                  questiontype: "FreeText",
                  datatype: "Varchar",
                  validinputtype: null,
                  selectedQuestionType: 1,
                  isVisibleResponseOptions: false,
                  responseoptions: [],
                },
              ],
            },
          ],
        },
      ],

      showDeleteSectionAlert: false,
      deleteSectionIndex: null,
      showDeleteQuestionAlert: false,
      deleteQuestionIndex: null,
      showPublishAlert: false,
    };

    this.newQuestionRowHTML = this.newQuestionRowHTML.bind(this);
    this.deleteQuestionRow = this.deleteQuestionRow.bind(this);
    this.addQuestionRow = this.addQuestionRow.bind(this);
    this.changeResponseType = this.changeResponseType.bind(this);
    this.addResponseOptions = this.addResponseOptions.bind(this);
    this.removeResponseOptions = this.removeResponseOptions.bind(this);
    this.publishDCGQuestion = this.publishDCGQuestion.bind(this);
  }

  componentDidMount() {
    this.getDCGQUestionTemplate();
    this.setUserInfo();
  }

  setUserInfo = () => {
    var userinfo = JSON.parse(localStorage.getItem("userinfo"));
    if (userinfo) {
      this.setState({
        loginname: userinfo.roleinfo.loginname,
        userloginid: userinfo.roleinfo.userloginid,
        userLoggedIn: true,
      });
    } else {
       localStorage.removeItem("userinfo");
this.props.history.push("/login");
      // return;
    }
  };

  // setUserInfo = () => {
  //     var userinfo = localStorage.getItem('userinfo');

  //     if(userinfo){
  //         userinfo = (userinfo) ? JSON.parse(localStorage.getItem('userinfo')) : null;
  //         this.setState({
  //             loginname: userinfo.roleinfo.loginname,
  //             userloginid: userinfo.roleinfo.userloginid
  //         })
  //     } else{
  //         return;
  //     }

  // }

  toggleToaster(message, type) {
    this.setState({
      toasterMessage: message,
      toasterType: type,
    });

    setTimeout(() => {
      this.setState({
        toasterMessage: null,
        toasterType: undefined,
      });
    }, 4000);
  }

  questionsTable = (paramquestions, sectionIndex, section) => {
    let questionsTableReturn = this.allquestionsRows(
      paramquestions,
      sectionIndex,
      section,
    );
    return questionsTableReturn;
  };

  allquestionsRows = (param, sectionIndex, section) => {
    const questionsItems = param.map((quest, questionIndex) =>
      this.newQuestionRowHTML(sectionIndex, section, questionIndex, quest),
    );
    return questionsItems;
  };

  checkOthersInResponseOptions(responseoptions) {
    if (
      responseoptions.includes("Other") ||
      responseoptions.includes("other")
    ) {
      return true;
    }
  }

  newQuestionRowHTML = (sectionIndex, section, questionIndex, question) => {
    if (
      question.is_delete ||
      (section.label === "Your Favorites" &&
        question.label.toLowerCase() != "Delivery".toLowerCase())
    ) {
      return null;
    }

    const questionTextId = `q-${questionIndex}`;
    const questionTypeSelectId = `qt-${questionIndex}`;

    var arr = [];
    if (question.questiontype === "CheckBox") {
      question.isVisibleResponseOptions = true;
    } else if (question.questiontype === "RadioButton") {
      question.isVisibleResponseOptions = true;
    } else if (question.questiontype === "SingleSelection") {
      question.isVisibleResponseOptions = true;
    } else {
      question.isVisibleResponseOptions = false;
    }

    Array.isArray(question.options) &&
      question.options.map((items, index) => {
        // if(!items.is_delete){
        if (!items.is_delete && items.label !== null) {
          arr.push(items.label);
        }
      });

    question.responseoptions = arr;

    let emptyQuestionRowHtml = (
      <section className="questions">
        <div className="row">
          <div className="col-md-1">
            <i className="fa fa-bars grey-bars" aria-hidden="true"></i>
          </div>
          <div className="col-md-10 pt-3 pb-3">
            <div className="row mbl-padding">
              <div className="col-md-3">
                <div className="form-group">
                  <label>Question</label>
                  {/* <input type="text" className="form-control" placeholder="What is your style?" /> */}
                  <input
                    type="text"
                    className={
                      question.label && question.label.trim("")
                        ? "form-control"
                        : "form-control field-error"
                    }
                    placeholder="What is your style?"
                    data-id={questionIndex}
                    className2="qlabel"
                    id={questionTextId}
                    name={questionTextId}
                    value={question.label}
                    onChange={(e) =>
                      this.onQuestionChange(e, sectionIndex, questionIndex)
                    }
                    disabled={
                      question.label.toLowerCase() === "Delivery".toLowerCase()
                    }
                  />
                </div>
              </div>
              <div className="col-md-1">
                <div className="form-group">
                  <label>Eloqua Id</label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Eloqua Id"
                    data-id={questionIndex}
                    className2="qeloquaid"
                    id={"e" + questionTextId}
                    name={"e" + questionTextId}
                    value={question.eloquaid}
                    onChange={(e) =>
                      this.onEloquaChange(e, sectionIndex, questionIndex)
                    }
                    disabled={
                      question.label.toLowerCase() === "Delivery".toLowerCase()
                    }
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="form-group">
                  <label>Response Type</label>
                  <select
                    className="form-control"
                    data-id={questionIndex}
                    className1="qtype"
                    id={questionTypeSelectId}
                    name={questionTypeSelectId}
                    value={question.questiontype}
                    onChange={(e) =>
                      this.changeResponseType(e, sectionIndex, questionIndex)
                    }
                    disabled={
                      question.label.toLowerCase() === "Delivery".toLowerCase()
                    }
                  >
                    {this.state.responseType &&
                      this.state.responseType.map((rtype, key) => (
                        <option key={key} value={rtype.responseTypeId}>
                          {rtype.responseType}
                        </option>
                      ))}
                  </select>
                </div>
              </div>
              <div className="col-md-5">
                <div className="form-group">
                  {question.isVisibleResponseOptions && (
                    <label>
                      Response Options{" "}
                      <small>(Type and press enter to add options)</small>
                    </label>
                  )}
                  <div className="position-box">
                    {question.isVisibleResponseOptions && (
                      <ReactChipInput
                        data-id={questionIndex}
                        className="qoptions"
                        classes={
                          question.responseoptions &&
                          question.responseoptions.length > 0
                            ? "form class1 class2"
                            : " field-error class1 class2"
                        }
                        value={question.responseoptions}
                        chips={question.responseoptions}
                        onSubmit={(value) =>
                          this.addResponseOptions(
                            sectionIndex,
                            questionIndex,
                            value,
                            question.label,
                          )
                        }
                        onRemove={(index) =>
                          this.removeResponseOptions(
                            sectionIndex,
                            questionIndex,
                            index,
                          )
                        }
                      />
                    )}
                    {question.isVisibleResponseOptions &&
                      !this.checkOthersInResponseOptions(
                        question.responseoptions,
                      ) &&
                      question.label.toLowerCase() !=
                        "Delivery".toLowerCase() && (
                        <div className="col-md-12 mt-3 text-right text-color">
                          <a
                            href="javascript:void(0);"
                            onClick={() =>
                              this.addResponseOptions(
                                sectionIndex,
                                questionIndex,
                                "Other",
                                question.label,
                              )
                            }
                          >
                            Add "Other"
                          </a>
                        </div>
                      )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {question.label.toLowerCase() != "Delivery".toLowerCase() && (
            <div className="col-md-1 pt-3 pr-4 text-right">
              <a
                onClick={() =>
                  this.deleteQuestionRow(sectionIndex, questionIndex)
                }
              >
                <i className="far fa-trash-alt trash"></i>
              </a>
            </div>
          )}
        </div>
      </section>
    );

    return emptyQuestionRowHtml;
  };

  // deleteQuestionRowConfirm onCancelDeleteQuestion showDeleteQuestionAlert deleteQuestionIndex

  deleteQuestionRow = (sectionIndex, questionIndex) => {
    this.setState({
      showDeleteQuestionAlert: true,
      deleteSectionIndex: sectionIndex,
      deleteQuestionIndex: questionIndex,
    });
  };

  deleteQuestionRowConfirm = () => {
    // this.state.dcgForm[0].sections[sectionIndex].questions[questionIndex].is_delete = true;
    this.state.dcgForm[0].sections[this.state.deleteSectionIndex].questions[
      this.state.deleteQuestionIndex
    ].is_delete = true;
    this.setState({ dcgForm: this.state.dcgForm });
    this.setState({
      showDeleteQuestionAlert: false,
      deleteSectionIndex: null,
      deleteQuestionIndex: null,
    });
  };

  onCancelDeleteQuestion = () => {
    this.setState({
      showDeleteQuestionAlert: false,
      deleteSectionIndex: null,
      deleteQuestionIndex: null,
    });
  };

  // deleteQuestionRow = (sectionIndex, questionIndex) => {
  //     // this.state.dcgForm[0].sections[sectionIndex].questions.splice(questionIndex, 1);

  //     this.state.dcgForm[0].sections[sectionIndex].questions[questionIndex].is_delete = true;
  //     this.setState({dcgForm: this.state.dcgForm})
  // }

  addQuestionRow = (sectionIndex) => {
    let tmpQuestionCount =
      this.state.dcgForm[0].sections[sectionIndex].questions.length;

    let tmpQuestion = {
      questionid: null,
      is_delete: false,
      questionorder: tmpQuestionCount + 1,
      label: "",
      labellength: 0,
      eloquaid: null,
      questiontype: "FreeText",
      datatype: "Varchar",
      validinputtype: null,
      selectedQuestionType: 1,
      isVisibleResponseOptions: false,
      responseoptions: [],
    };

    let tmpdcgForm = this.state.dcgForm;
    let tmpquestions = [
      ...this.state.dcgForm[0].sections[sectionIndex].questions,
      tmpQuestion,
    ];
    tmpdcgForm[0].sections[sectionIndex].questions = tmpquestions;

    this.setState((prevState) => ({
      dcgForm: [...tmpdcgForm],
    }));

    // let tmpQuestion = {questionid: null, is_delete: false, questionorder: null, label:'', labellength:0, eloquaid:null, questiontype:'FreeText', datatype:'Varchar', validinputtype:null, selectedQuestionType:1, isVisibleResponseOptions:false, responseoptions:[]};

    // let tmpdcgForm = this.state.dcgForm;
    // let tmpquestions = [ ...this.state.dcgForm[0].sections[sectionIndex].questions, tmpQuestion ];
    // tmpdcgForm[0].sections[sectionIndex].questions = tmpquestions;

    // this.setState(prevState => ({
    //     dcgForm: [...tmpdcgForm]
    // }))
  };

  changeResponseType(event, sectionIndex, questionIndex) {
    let tmpdcgForm = this.state.dcgForm;
    let tmpquestions = [
      ...this.state.dcgForm[0].sections[sectionIndex].questions,
    ];
    tmpquestions[questionIndex].questiontype = event.target.value;
    if (Number(event.target.value) === 1) {
      tmpquestions[questionIndex].isVisibleResponseOptions = false;
    } else {
      tmpquestions[questionIndex].isVisibleResponseOptions = true;
    }

    tmpdcgForm[0].sections[sectionIndex].questions = tmpquestions;
    this.setState((prevState) => ({
      dcgForm: [...tmpdcgForm],
    }));
  }

  onQuestionChange = (event, sectionIndex, questionIndex) => {
    let tmpdcgForm = this.state.dcgForm;
    let tmpquestions = this.state.dcgForm[0].sections[sectionIndex].questions;
    tmpquestions[questionIndex].label = event.target.value;
    tmpdcgForm[0].sections[sectionIndex].questions = tmpquestions;

    this.setState((prevState) => ({
      dcgForm: [...tmpdcgForm],
    }));
  };

  onEloquaChange = (event, sectionIndex, questionIndex) => {
    let tmpdcgForm = this.state.dcgForm;
    let tmpquestions = this.state.dcgForm[0].sections[sectionIndex].questions;
    tmpquestions[questionIndex].eloquaid = event.target.value;
    tmpdcgForm[0].sections[sectionIndex].questions = tmpquestions;

    this.setState((prevState) => ({
      dcgForm: [...tmpdcgForm],
    }));
  };

  addResponseOptions = (sectionIndex, questionIndex, value, questionlabel) => {
    var options = [];
    if (questionlabel.toLowerCase() === "Delivery".toLowerCase()) {
      /^(?:[1-9]\d*|0)?(?:\.\d+)?$/.test(value) && value
        ? (value = "$" + value)
        : (value = "");
    }
    if (value !== "" && value && value.trim("") != "") {
      if (value.toLowerCase() == "other") {
        value = "Other";
      }
      var newOption = { optionid: 0, label: value, is_delete: false };
      if (
        this.state.dcgForm[0].sections[sectionIndex].questions[questionIndex]
          .options &&
        Array.isArray(
          this.state.dcgForm[0].sections[sectionIndex].questions[questionIndex]
            .options,
        )
      ) {
        options =
          this.state.dcgForm[0].sections[sectionIndex].questions[
            questionIndex
          ].options.slice();
        options.push(newOption);
      } else {
        options.push(newOption);
      }
      let tmpdcgForm = this.state.dcgForm;
      let tmpquestions = this.state.dcgForm[0].sections[sectionIndex].questions;
      tmpquestions[questionIndex].options = options;
      tmpdcgForm[0].sections[sectionIndex].questions = tmpquestions;

      this.setState((prevState) => ({
        dcgForm: [...tmpdcgForm],
      }));
    }
  };

  removeResponseOptions = (sectionIndex, questionIndex, index) => {
    var options =
      this.state.dcgForm[0].sections[sectionIndex].questions[questionIndex]
        .options;
    options.filter((data) => data.is_delete == false)[index].is_delete = true;

    let tmpdcgForm = this.state.dcgForm;
    let tmpquestions = this.state.dcgForm[0].sections[sectionIndex].questions;
    tmpquestions[questionIndex].options = options;
    tmpdcgForm[0].sections[sectionIndex].questions = tmpquestions;

    this.setState((prevState) => ({
      dcgForm: [...tmpdcgForm],
    }));

    // // const options = this.state.dcgForm[0].sections[sectionIndex].questions[questionIndex].options.slice();
    // // options.splice(index, 1);

    // var options = this.state.dcgForm[0].sections[sectionIndex].questions[questionIndex].options;
    // options = options.filter(data => data.is_delete == false);
    // options[index].is_delete = true;

    // let tmpdcgForm = this.state.dcgForm;
    // let tmpquestions = this.state.dcgForm[0].sections[sectionIndex].questions;
    // tmpquestions[questionIndex].options = options;
    // tmpdcgForm[0].sections[sectionIndex].questions = tmpquestions;

    // // this.toggleToaster("Response Options Updated Successsfully", "success");

    // this.setState(prevState => ({
    //     dcgForm: [...tmpdcgForm]
    // }))
  };

  // ///////// section////////////////////////////

  onChangeSectionLabel = (event, sectionIndex) => {
    let tmpdcgForm = this.state.dcgForm;
    let tmpSectionList = this.state.dcgForm[0].sections;

    tmpSectionList[sectionIndex].label = event.target.value;

    tmpdcgForm[0].sections = tmpSectionList;

    this.setState((prevState) => ({
      dcgForm: [...tmpdcgForm],
    }));
  };

  deleteSectionRow = (sectionIndex) => {
    this.setState({
      showDeleteSectionAlert: true,
      deleteSectionIndex: sectionIndex,
    });
  };

  deleteSectionRowConfirm = () => {
    let tmpdcgForm = this.state.dcgForm;
    let tmpSectionList = this.state.dcgForm[0].sections;
    tmpSectionList[this.state.deleteSectionIndex].is_delete = true;
    tmpSectionList[this.state.deleteSectionIndex].is_delete = true;
    if (
      tmpSectionList[this.state.deleteSectionIndex] &&
      tmpSectionList[this.state.deleteSectionIndex].questions
    ) {
      tmpSectionList[this.state.deleteSectionIndex].questions.map((q) => {
        q.is_delete = true;
      });
    }
    tmpdcgForm[0].sections = tmpSectionList;

    this.setState((prevState) => ({
      dcgForm: [...tmpdcgForm],
      showDeleteSectionAlert: false,
    }));
  };

  onCancelDeleteSection = () => {
    this.setState({
      showDeleteSectionAlert: false,
      deleteSectionIndex: null,
    });
  };

  // deleteSectionRow = (sectionIndex) => {
  //     let tmpdcgForm = this.state.dcgForm;
  //     let tmpSectionList = this.state.dcgForm[0].sections;

  //     // tmpSectionList.splice(sectionIndex, 1);
  //     tmpSectionList[sectionIndex].is_delete = true;

  //     tmpdcgForm[0].sections = tmpSectionList;

  //      this.setState(prevState => ({
  //         dcgForm: [...tmpdcgForm]
  //       }))

  // }

  addSectionRow = (sectionIndex) => {
    let tmpSection = {
      sectionid: null,
      is_delete: false,
      label: "",
      description: "",
      questions: [
        {
          questionid: null,
          is_delete: false,
          questionorder: 1,
          label: "",
          labellength: 0,
          eloquaid: null,
          questiontype: "FreeText",
          datatype: "Varchar",
          validinputtype: null,
          selectedQuestionType: 1,
          isVisibleResponseOptions: false,
          responseoptions: [],
        },
      ],
    };

    let tmpdcgForm = this.state.dcgForm;
    let tmpSectionList = this.state.dcgForm[0].sections;
    tmpSectionList = [...tmpSectionList, tmpSection];
    tmpdcgForm[0].sections = tmpSectionList;

    this.setState((prevState) => ({
      dcgForm: [...tmpdcgForm],
    }));
  };

  sectionListTable = () => {
    let sectionTable = this.allSectionListRows(this.state.dcgForm[0].sections);
    return sectionTable;
  };

  allSectionListRows = (param) => {
    const sectionListItems = param.map((sect, index) =>
      this.newSectionRowHTML(index, sect),
    );
    return sectionListItems;
  };

  newSectionRowHTML = (sectionIndex, section) => {
    // console.log('sectionIndex ',sectionIndex)
    // if(section.is_delete){
    //     return null;
    // }
    if (
      section.is_delete ||
      section.label.toLowerCase() === "notes" ||
      section.label.toLowerCase() === "Upholstery".toLowerCase() ||
      section.label.toLowerCase() ==
        "Tables, Lamps, Rugs, Accessories".toLowerCase() ||
      section.label.toLowerCase() == "More about the customer".toLowerCase()
    ) {
      return null;
    }

    const sectionTextId = `s-${sectionIndex}`;
    const sectionDeleteButtonId = `sec-${sectionIndex}`;
    let sectionRowHtml = (
      <div className="card card-primary">
        <div className="card-header pt-0 pb-0">
          <div className="row">
            <div className="col-md-6 mt-2 mb-2">
              <div className="row d-flex-right">
                <div className="col-md-2">
                  <h3 className="card-title">
                    <i className="fa fa-bars" aria-hidden="true"></i> Section
                  </h3>
                </div>
                <div className="col-md-10">
                  {/* <input type="text" className="form-control" placeholder="Tell me About Your Room - Design" /> */}
                  <input
                    type="text"
                    className={
                      section.label && section.label.trim("")
                        ? "form-control"
                        : "form-control section-field-error"
                    }
                    placeholder="Tell me About Your Room - Design"
                    data-id={sectionIndex}
                    className2="slabel"
                    id={sectionTextId}
                    name={sectionTextId}
                    value={section.label}
                    onChange={(e) => this.onChangeSectionLabel(e, sectionIndex)}
                    disabled={
                      section.label.toLowerCase() ===
                      "Your Favorites".toLowerCase()
                    }
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6 mt-2 mb-2 text-right d-flex-right">
              {section.label.toLowerCase() !=
                "Your Favorites".toLowerCase() && (
                <a
                  className="btn  btn-default btn-sm mr-3"
                  onClick={() => this.addQuestionRow(sectionIndex)}
                >
                  Add a Question
                </a>
              )}
              {sectionIndex > 1 &&
                section.label.toLowerCase() !=
                  "Your Favorites".toLowerCase() && (
                  <a
                    className="btn  btn-default btn-sm mr-3"
                    onClick={() => this.deleteSectionRow(sectionIndex)}
                  >
                    Delete Section
                  </a>
                )}
              <div className="card-tools">
                <button
                  type="button"
                  className="btn btn-tool"
                  data-card-widget="collapse"
                >
                  <i className="fas fa-minus"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="card-body grey-bg-card">
          {/* <!-- /.individual question section start --> */}
          {this.questionsTable(section.questions, sectionIndex, section)}
        </div>
      </div>
    );
    return sectionRowHtml;
  };
  getrefreshtoken(actionPayload) {
    getRefreshToken()
      .then((res) => {
        api
          .getStoreComparisonDataPost(actionPayload)
          .then((data) => {
            this.setState({
              comparisonData: data.data.data,
              spinnerLoading: false,
            });
            this.getMarketData();
          })
          .catch((error) => {
            console.log("Error : " + error);
          });
      })
      .catch((err) => {
         localStorage.removeItem("userinfo");
this.props.history.push("/login");
      });
  }
  getDCGQUestionTemplate() {
    try {
      this.setState({ spinnerLoading: true });
      var actionPayload = {
        startDate: "2021-03-01",
        endDate: "2021-03-25",
        salesrepid: null,
        storeId: [],
      };
      api
        .getDCGQUestionTemplate()
        .then((data) => {
          if (data && data.response && data.response.status == 401) {
                localStorage.removeItem("userinfo");
this.props.history.push("/login");
          } else {
            this.setState({
              dcgForm: [data],
            });
            this.setState({ spinnerLoading: false });
            console.log(this.state.dcgForm[0]);
          }
        })
        .catch((error) => {
          console.log("Error : " + error);
          this.toggleToaster(
            "Failed to retrieve data from the API. Please try again later.",
            "error",
          );
        });
    } catch (e) {}
  }

  // showPublishAlert publishDCGQuestionConfirm onCancelPublishAlert

  publishDCGQuestion = () => {
    this.setState({
      showPublishAlert: true,
    });
  };

  onCancelPublishAlert = () => {
    this.setState({
      showPublishAlert: false,
    });
  };

  publishDCGQuestionConfirm = () => {
    this.setState({
      showPublishAlert: false,
    });
    try {
      var publishObj = {
        templateid: null,
        loginname: this.state.loginname,
        userloginid: this.state.userloginid,
        sections: this.state.dcgForm[0].sections,
      };
      var errors = false;

      publishObj.sections.forEach((section) => {
        if (section.is_delete === false && section.label == "") {
          this.toggleToaster("Some required fields are missing", "error");
          this.setState({ showPublishAlert: false });
          errors = true;
        }
        section.questions.forEach((question) => {
          if (question.is_delete === false && question.responseoptions) {
            if (question.label === "" || question.label == null) {
              this.toggleToaster("Some required fields are missing", "error");
              this.setState({ showPublishAlert: false });
              errors = true;
            }
            if (
              question.questiontype !== "FreeText" &&
              question.questiontype !== "TextArea" &&
              question.responseoptions.length == 0
            ) {
              this.toggleToaster("Some required fields are missing", "error");
              this.setState({ showPublishAlert: false });
              errors = true;
            }
          }
        });
      });

      if (errors == false) {
        api
          .publishDCGQuestion(publishObj)
          .then((data) => {
            if (data && data.response && data.response.status == 401) {
                  localStorage.removeItem("userinfo");
this.props.history.push("/login");
            } else {
              this.setState({ showPublishAlert: false });
              this.toggleToaster("Updated Successfully", "success");
              setTimeout(this.getDCGQUestionTemplate(), 2000);
            }
          })
          .catch((error) => {
            console.log("Error : " + error);
            this.setState({ showPublishAlert: false });
            this.toggleToaster(
              "Failed to retrieve data from the API. Please try again later.",
              "error",
            );
          });
      }
    } catch (e) {}

    // var publishObj = {templateid: 302, sections: this.state.dcgForm[0].sections};

    // console.log('publishObj ');
    // console.log(publishObj);

    // this.state.dcgForm[0].sections[sectionIndex].questions.splice(questionIndex, 1);
    // this.setState({dcgForm: this.state.dcgForm})
  };

  // publishDCGQuestion = () => {
  //     try {
  //         var publishObj = {templateid: null, loginname:this.state.loginname, userloginid:this.state.userloginid, sections: this.state.dcgForm[0].sections};
  //         // var publishObj = {templateid: 1, sections: this.state.dcgForm[0].sections};
  //         // console.log('publishObj ');
  //         // console.log(publishObj);
  //         api.publishDCGQuestion(publishObj).then((data) => {
  //             // console.log('after publishing data result data');
  //             // console.log(data);
  //             this.toggleToaster("Updated Successsfully", "success");
  //             setTimeout(this.getDCGQUestionTemplate(), 2000);
  //         }).catch((error) => {
  //             console.log('Error : ' + error);
  //         });
  //     } catch (e) {
  //     }

  //     // var publishObj = {templateid: 302, sections: this.state.dcgForm[0].sections};

  //     // console.log('publishObj ');
  //     // console.log(publishObj);

  //     // this.state.dcgForm[0].sections[sectionIndex].questions.splice(questionIndex, 1);
  //     // this.setState({dcgForm: this.state.dcgForm})

  // }

  render() {
    return (
      <div className="wrapper">
        <Header />
        <Sidebar tab={this.state.tab} tabchangeevent={this.tabchangeevent} />
        <IdleTimer></IdleTimer>
        <LoadingOverlay
          active={this.state.spinnerLoading}
          spinner={<BounceLoader />}
          className={loaderStyle}
        >
          <div className="content-wrapper pb-4">
            {this.state.toasterMessage ? (
              <Toaster
                message={this.state.toasterMessage}
                toasterType={this.state.toasterType}
              />
            ) : null}
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-6">
                    <h5 className="mt-2 mb-0">
                      Digital Comfort Guide Questions
                    </h5>
                  </div>
                  <div className="col-md-6 text-right">
                    <a
                      onClick={() => this.publishDCGQuestion()}
                      href="javascript:void(0);"
                      className="btn btn-primary pt-2"
                    >
                      Publish
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <hr />
                  </div>
                  <div className="col-md-12">
                    <a
                      onClick={this.addSectionRow}
                      className="btn btn-outline-primary pt-2"
                    >
                      Add a Section
                    </a>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <hr />
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">{this.sectionListTable()}</div>
                </div>
              </div>
            </section>

            {this.state.showDeleteSectionAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Yes, delete!"
                style={{ color: "#000000", fontSize: "11px", minWidth: "30%" }}
                title="Are you sure to delete section?"
                onConfirm={this.deleteSectionRowConfirm}
                onCancel={this.onCancelDeleteSection}
                focusCancelBtn={true}
                closeOnClickOutside={true}
                allowEscape={true}
                btnSize={"sm"}
              >
                <span style={{ color: "#000000", fontSize: "12px" }}>
                  You will not be able to recover this section!
                </span>
              </SweetAlert>
            )}

            {this.state.showDeleteQuestionAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Yes, delete!"
                style={{ color: "#000000", fontSize: "11px", minWidth: "30%" }}
                title="Are you sure to delete question?"
                onConfirm={this.deleteQuestionRowConfirm}
                onCancel={this.onCancelDeleteQuestion}
                focusCancelBtn={true}
                closeOnClickOutside={true}
                allowEscape={true}
                btnSize={"sm"}
              >
                <span style={{ color: "#000000", fontSize: "12px" }}>
                  You will not be able to recover this question!
                </span>
              </SweetAlert>
            )}

            {this.state.showPublishAlert && (
              <SweetAlert
                showCancel
                confirmBtnText="Yes, publish!"
                cancelBtnStyle={{ color: "#003349" }}
                style={{ color: "#000000", fontSize: "11px", minWidth: "30%" }}
                title="Are you sure to update base template?"
                onConfirm={this.publishDCGQuestionConfirm}
                onCancel={this.onCancelPublishAlert}
                focusCancelBtn={true}
                closeOnClickOutside={true}
                allowEscape={true}
                btnSize={"sm"}
              >
                <span style={{ color: "#000000", fontSize: "12px" }}>
                  Your base template content will be changed into new one!
                </span>
              </SweetAlert>
            )}
          </div>
        </LoadingOverlay>
        <Footer />
        <aside className="control-sidebar control-sidebar-dark"></aside>
      </div>
    );
  }
}
export default withRouter(DCGQuestions);
